import styled from 'styled-components';

import { grey10, grey6 } from 'approot/shared/styles/colours.style';
import {
  fontWeightMedium,
  PStyled,
} from 'approot/shared/styles/typography.style';
import { rem } from 'approot/shared/style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { spacing16, spacing4 } from 'approot/shared/styles/spacing.style';
import { ACTIVITY_BUILDER_A4_SHORT_SIDE } from 'approot/activity-builder/activity-builder.constants';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ActivityAnswersPrintIntro = styled.div`
  height: ${rem(ACTIVITY_BUILDER_A4_SHORT_SIDE)};
  padding: ${rem(80)};
  position: relative;
`;

export const ActivityAnswersPrintText = styled(PStyled).attrs({
  colour: grey6,
  marginBottom: spacing4,
})``;

export const ActivityAnswersPrintValue = styled(PStyled).attrs({
  colour: grey10,
})`
  font-weight: ${fontWeightMedium};
`;

export const ActivityAnswersPrintImageWrapper = styled.div`
  border-radius: ${rem(borderRadius16)};
  overflow: hidden;
  width: ${rem(383)};
  height: ${rem(287)};
`;

export const ActivityAnswersPrintImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const ActivityAnswersPrintDetails = styled.div`
  flex: 1;
`;

export const ActivityAnswersPrintImageDetails = styled.div`
  width: ${rem(383)};
`;

export const ActivityAnswersPrintLogo = styled.div`
  ${flexCentreAlignCss}
  position: absolute;
  bottom: ${rem(spacing16)};
  left: ${rem(spacing16)};
  right: ${rem(spacing16)};

  svg {
    height: ${rem(40)};
    width: ${rem(120)};
    position: relative;
  }
`;
